export {WSpinner, useSpinner} from './WSpinner';